import styled from 'styled-components'
import { LinkButton } from '@sketch/components'

export const Link = styled(LinkButton)`
  min-height: 32px;
  padding: 4px 8px;
  padding-left: 10px; /* stylelint-disable-line scales/space */
  font-size: ${({ theme }) => theme.fontSizes.D};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  box-shadow: none;

  &,
  :hover,
  :focus,
  :active {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }

  &[disabled] {
    opacity: 0.5;
  }
`

export const IconContainer = styled.div`
  width: 16px;
  height: 16px;
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  & > * {
    width: 16px;
    height: 16px;
  }
`
